import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

import { concluirAberturaDoChamado, resolverWidDoChamado } from '@/lib/chamado-redirect'

import { TelaContestarPeloLink } from '@/features/meus-alertas/chamado'

export const Route = createFileRoute('/chamado')({
  component: Chamado,
})

/**
 * Contestação pelo link do comentário no GitLab. Fica fora do menu lateral e
 * vale para qualquer pessoa que entra no painel.
 */
function Chamado() {
  // Fim do desvio pelo link do comentário: o painel volta a desenhar normalmente.
  useEffect(() => {
    concluirAberturaDoChamado()
  }, [])
  return <TelaContestarPeloLink wid={resolverWidDoChamado()} />
}
